import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "users-table--name-concat-cell" }
const _hoisted_2 = { class: "users-table--name-concat-cell-content" }
const _hoisted_3 = { class: "rounded-sm" }
const _hoisted_4 = ["data-cy-user-name"]
const _hoisted_5 = ["data-testid", "data-cy-user-name"]
const _hoisted_6 = { class: "rounded-sm w-fit" }

import { computed, ref } from 'vue';
import { IncrediTooltip } from 'incredi-ui';
import { User_AdditionalInfo } from '@/graphql/codegen/generated/graphql';
import elementIds from '@/const/elementIds.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNameCell',
  props: {
    username: null,
    email: null,
    isHovered: { type: Boolean },
    isActive: { type: Boolean },
    selected: { type: Boolean }
  },
  emits: ["editUser"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line no-unused-vars
  (e: 'editUser'): void;
}), expose: any, slots: any, attrs: any }) {

const tooltips = ref({
  name: false,
  email: false,
});

const usernameOverflow = ref();
const emailOverflow = ref();

const isUsernameOverflow = computed(() => usernameOverflow.value?.offsetWidth < usernameOverflow.value?.scrollWidth);
const isEmailOverflow = computed(() => emailOverflow.value?.offsetWidth < emailOverflow.value?.scrollWidth);

const handleTooltip = (value: boolean, whichTooltip: 'name' | 'email') => {
  tooltips.value[whichTooltip] = value;
};





const handleEditUser = () => {
  emit('editUser');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_unref(IncrediTooltip), {
          direction: "top-middle",
          "model-value": tooltips.value.name && _unref(isUsernameOverflow),
          delay: 200,
          hover: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (value)=>handleTooltip(value, 'name'))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.username), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              ref_key: "usernameOverflow",
              ref: usernameOverflow,
              "data-testid": "users-table--name-concat-cell-username",
              "data-cy-user-name": __props.username,
              class: _normalizeClass(["overflow-hidden text-ellipsis font-gordita-medium text-[13px]", { 'underline cursor-pointer text-Text/text_high': __props.isHovered || __props.selected, 'text-Text/text_high': __props.isActive }]),
              onClick: handleEditUser
            }, _toDisplayString(__props.username), 11, _hoisted_4)
          ]),
          _: 1
        }, 8, ["model-value"])
      ]),
      (__props.email?.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "data-testid": _unref(elementIds).users.table.cells.email,
            "data-cy-user-name": __props.username
          }, [
            _createVNode(_unref(IncrediTooltip), {
              direction: "top-middle",
              "model-value": tooltips.value.email && _unref(isEmailOverflow),
              delay: 200,
              hover: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (value)=>handleTooltip(value, 'email'))
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(__props.email), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  ref_key: "emailOverflow",
                  ref: emailOverflow,
                  class: _normalizeClass(["overflow-hidden text-ellipsis width-fit", { 'text-Text/text_medium': __props.isActive }])
                }, _toDisplayString(__props.email), 3)
              ]),
              _: 1
            }, 8, ["model-value"])
          ], 8, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})